var path = 'msi/subscriptions/cancel/cancel-subscription-button.html';
var html = "<a ui-sref=\"cancel({ subscription: $ctrl.subscription })\" href=\"javascript:void(0);\">\n  {{'CANCEL_SUBSCRIPTION_BUTTON' | translate}}\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;